
import React from "react";
import { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import NotFound from "../pages/NotFound";
import GalleryPage from "../pages/gallery/page";
import ServicesPage from "../pages/services/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: React.createElement(Home),
  },
  {
    path: "/services",
    element: React.createElement(ServicesPage),
  },
  {
    path: "/contact",
    element: React.createElement(ContactPage),
  },
  {
    path: "/gallery/:slug",
    element: React.createElement(GalleryPage),
  },
  {
    path: "*",
    element: React.createElement(NotFound),
  },
];

export default routes;
